import styled from "styled-components";
import {
    Color,
    Font,
    breakpoints,
    ColorDark,
  } from "@/shared/Constants";


  export const ContainerBtnGroupCollection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  padding: 0.5rem 1rem;
  button {
      all: unset;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 44px;
      border-radius: 22px;
      letter-spacing: -0.21px;
      color: ${Color.grey};
      ${Font.sansRegular};
      cursor: pointer;
      background-color: ${Color.white};
      border: 1px solid ${Color.grey};
      &:last-of-type {
          background-color: ${Color.grey};
          color: ${Color.white};
      }
  }
`;